import WarrantyAssociation from '@/components/warranties/WarrantyAssociation'

// Nextjs

// UI
import Breadcrumbs from '@/components/ui/Breadcrumbs'

export default function WarrantyAssociatePage() {
    const breadcrumbs = [
        {
            label: 'Garanties',
            href: '/warranties',
        },
        {
            label: 'Associer des garanties',
        },
    ]
    return (
        <div>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <div className="bg-white max-w-[600px] mx-auto mt-5 border rounded-sm">
                <WarrantyAssociation />
            </div>
        </div>
    )
}
